module.exports = __webpack_public_path__ + "media/warranty-claim/proof-of-roof.success-c0c02155.svg";